module.exports = __webpack_public_path__ + "files/83f8b326ade537b52c54593f448e980e.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Main-Bold.woff2
// module id = 1141
// module chunks = 60